// =============================================================================
// CaseworkerNotesStrip.jsx
// =============================================================================
// The small yellow "Caseworker notes" strip staff see at the top of a request.
//
// It shows the caseworker's ONE-TIME SUBMISSION NOTE — the free-text note the
// DFV Service entered on the New Request form. That note has its OWN field
// (requests.caseworker_note, db-120) and is read directly here.
//
// HISTORY: this used to read req.notes[0] and guess whether that first note was
// a submission note by matching its author against the shelter/contact name.
// That was fragile — when a responder's name collided with the shelter's contact
// name (e.g. a responder approving their own service's request), the staff
// approval-summary comment satisfied the heuristic and leaked into this strip.
// The submission note now has its own home, so there is nothing to guess.
//
// Props
// ─────
//   req — request object (read for caseworkerNote)
// =============================================================================
export function CaseworkerNotesStrip({ req }) {
  const note = req.caseworkerNote;
  if (!note) return null;
  return (
    <div
      style={{
        background: "#FFFDE7",
        border: "1px solid #FFD54F",
        borderRadius: 8,
        padding: "10px 14px",
        marginBottom: 14,
        fontSize: 13,
        color: "#5D4037",
      }}
    >
      <span
        style={{
          fontWeight: 700,
          fontSize: 11,
          textTransform: "uppercase",
          letterSpacing: 0.4,
          display: "block",
          marginBottom: 4,
          color: "#8a6000",
        }}
      >
        Caseworker notes
      </span>
      {note}
    </div>
  );
}
